import styled from "styled-components";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import { getUUID } from "../../utility";
import Container from "../UI/Container/Container";
import friedrich from "../../assets/image/career/contact/friedrich.webp";
import kathrin from "../../assets/image/career/contact/kathrin.webp";

const blue = "rgb(0, 79, 139)";
const personImages = [friedrich, kathrin];

type PersonType = {
  name: string;
  title: string;
  subtitle?: string;
  mail: string;
};

const StyledContact = styled.div`
  margin-top: 200px;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  @media (max-width: 992px) {
    margin-top: 100px;
  }
`;

const Headline = styled.div`
  font-size: 32px;
  color: ${blue};
  text-align: center;
`;

const Split = styled.div`
  display: flex;
  gap: 75px;
  margin-top: 50px;
  align-items: center;
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 50px;
  }
`;

const Person = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
  width: 100%;
  justify-content: center;
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

const PersonImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 200px;
  object-fit: cover;
  object-position: center;
`;

const Detail = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
`;

const Name = styled.div`
  color: ${blue};
  font-weight: bold;
  font-size: 22px;
`;

const Mail = styled.a`
  text-decoration: none;
  color: ${blue};
`;

const CareerContact = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <StyledContact>
      <Container>
        <Headline>{t.career.contact.headline}</Headline>
        <Split>
          {t.career.contact.people.map((person: PersonType, i: number) => (
            <Person key={getUUID()}>
              <PersonImage src={personImages[i]} alt={person.name} />
              <Detail>
                <Name>{person.name}</Name>
                <div>{person.title}</div>
                {person.subtitle && <div>{person.subtitle}</div>}
                <Mail href={`mailto:${person.mail}`}>{person.mail}</Mail>
              </Detail>
            </Person>
          ))}
        </Split>
      </Container>
    </StyledContact>
  );
};

export default CareerContact;
